<template>
  <b-modal
    :active.sync="showModal"
    trap-focus
    aria-role="dialog"
    aria-modal
    has-modal-card
    @close="closeModal"
  >
    <div class="modal-card" style="width: 700px" v-if="entry">
      <header class="modal-card-head">
        <p class="modal-card-title">
          Update Gym Name: #{{ entry.entrynumber }} - {{ entry.teamname }}
        </p>
      </header>
      <section class="modal-card-body">
        <div>
          <ValidationObserver ref="observer" v-slot="{ passes }">
            <form @submit.prevent="passes(submit)">
              <BaseInput
                v-model="entry.gymname"
                label="Gym Name"
                rules="required"
                v-if="!event.config || !event.config.predefinedgyms"
              />
              <BaseSelect
                v-model="entry.gymname"
                label="Gym Name"
                rules="required"
                v-else
              >
                <option v-for="gym in event.config.predefinedgyms" :key="gym">
                  {{ gym }}
                </option>
              </BaseSelect>
              <div class="has-margin-top-10">
                <button class="button" type="button" @click="closeModal">
                  Close
                </button>
                <button
                  class="button is-primary has-margin-left-5"
                  type="submit"
                  @click.prevent="passes(submit)"
                >
                  Update
                </button>
              </div>
            </form>
          </ValidationObserver>
        </div>
      </section>
    </div>
  </b-modal>
</template>

<script>
import EventEntryApi from '@/api/event-entry'
import BaseSelect from '@/components/BaseSelect'

export default {
  name: 'UpdateGymNameModal',
  components: {
    BaseSelect,
  },
  props: {
    show: {
      type: Boolean,
      default: false,
    },
    entry: {
      type: Object,
      default: null,
    },
    event: {
      type: Object,
      default: null,
    },
  },
  data() {
    return {
      loading: false,
      showModal: this.show,
      item: null,
    }
  },
  watch: {
    show() {
      this.showModal = this.show
    },
    entry() {
      this.item = this.entry
    },
  },
  methods: {
    async submit() {
      await EventEntryApi.updateGymname(this.entry)
      this.showModal = false
      this.$emit('close-modal')
      this.$buefy.toast.open({
        message: 'Gym name updated successfully.',
        position: 'is-top',
        type: 'is-success',
      })
    },
    closeModal() {
      this.showModal = false
      this.$emit('close-modal')
    },
  },
}
</script>
